export default __webpack_public_path__ + "static/image-49-247079c7d7e4c3c371a09715cf7075f9.jpg";